<template>
  <div class="accordion-item">
    <h2 class="accordion-header" id="booking-type-select-accordion-header">
      <button 
        class="accordion-button collapsed" 
        :class="{ collapsed: !isActive }"
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#booking-type-select-accordion-body" 
        :aria-expanded="isActive"
        aria-controls="booking-type-select-accordion-body"
        :disabled="!wizardStore.isStepEnabled(2)"
        @click="wizardStore.toggleStep(2)">
        2. {{ $t("Hvem skal du melde på?") }}
        <span class="fa fa-check float-right text-success ms-2"
          :class="{ 'd-none': !wizardStore.isStepCompleted(2) }"
          style="line-height: 24px"></span>
      </button>
    </h2>
    <div id="booking-type-select-accordion-body"
      class="accordion-collapse collapse"
      :class="{ show: (isActive || (vippsUser.exists && !wizardStore.isStepCompleted(3))) }"
      data-bs-parent="#booking-accordions">
      <div class="accordion-body">
        <div class="form-group mb-0">
          <select
            v-model="userType"
            name="user-type"
            id="user-type"
            class="form-control"
            @change="wizardStore.selectUserType(userType)">
            <option value="">- {{ $t("Velg") }} -</option>
            <option value="0" :disabled="vippsUser.exists">{{ $t("Jeg er elev") }}</option>
            <option value="2">{{ $t("Jeg er kontaktperson til en elev") }}</option>
          </select>
        </div>

        <!-- Student exists message -->
        <div v-if="vippsUser.exists && userType === '2'" class="alert alert-info mt-2">
            Du er allerede registrert som elev på {{ officeName }}.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import wizardStore from '../../state/vippsWizardStore.js'

const props = defineProps({
  isActive: Boolean
})

// Computed properties
const userType = computed({
  get: () => wizardStore.state.userType.value,
  set: (value) => { wizardStore.state.userType.value = value }
})
const vippsUser = computed(() => wizardStore.state.vippsUser.value)
const officeName = computed(() => wizardStore.state.officeName.value)
const showOnlyStep4 = computed(() => wizardStore.state.showOnlyStep4?.value || false)
</script>

